/*
shared-constants.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('sharedConstants',['angular'], function () {

    // Module Dependencies
    var dependencies = [];

    // Module Definition
    var mod = angular.module('Services.SharedConstants', dependencies);

    /**
     * @name sharedMessages
     * @type factory
     *
     * @description
     * A factory that provides localized messages.
     */
    mod.factory('sharedConstants', function () {

        /*return alert messages used across the application*/
        var getAlertMessages = function () {
            return {
                'SHOW_SUCCESS_MESSAGE': 'SHOW_SUCCESS_MESSAGE',
                'SHOW_FAILURE_MESSAGE': 'SHOW_FAILURE_MESSAGE',
                'SHOW_INFO_MESSAGE': 'SHOW_INFO_MESSAGE',
                'SHOW_SUCCESS_MESSAGE_NO_TIMEOUT': 'SHOW_SUCCESS_MESSAGE_NO_TIMEOUT',
                'SHOW_FAILURE_MESSAGE_NO_TIMEOUT': 'SHOW_FAILURE_MESSAGE_NO_TIMEOUT',
                'SHOW_INFO_MESSAGE_NO_TIMEOUT': 'SHOW_INFO_MESSAGE_NO_TIMEOUT'
            };
        };

        // Public API
        return {
            getAlertMessages: getAlertMessages
        };

    });

});

